<script>
</script>

<footer class="footer">
	<div class="container">
		<div class="loder-col">
			<div class="loder-title">Loder</div>
			<div class="loder-copyright">©Loder, 2023. All right reserved.</div>
		</div>
		<nav class="footer__nav">
			<div class='footer__link b1'><img src="../assets/icons/Message_alt_fill.svg" alt="Company email team@loder.app">team@loder.app</div>
			<div class="development-by-col">
				<div class="development-by">
					Development by
				</div>
				<a href="https://cadmean.dev/"  target="_blank" class="cadmean-row">
					<img class="cadmean-logo" alt="Cadmean" src="../assets/logo/Cadmean.svg">
					<div class="cadmean-title">Cadmean</div>
				</a>
			</div>
		</nav>
	</div>
</footer>

<style>
	.footer {
		padding: 70px 0;
		background-color: var(--color-primary-500);
	}
	.container {
		max-width: 1180px;
		margin: 0 auto;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0px 10px;
	}
	.footer__nav {
		display: flex;
		gap: 15px;
		flex-direction: column;
		align-items: end;
	}
	.footer__link {
		color: var(--text-color-white);
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.loder-col {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.loder-title {
		color: white;
		font-size: 32px;
		font-family: Source Sans Pro;
		font-weight: 600;
		line-height: 40px;
		word-wrap: break-word;
	}
	.loder-copyright {
		color: #B2B6CC;
		font-size: 14px;
		font-family: Source Sans Pro;
		font-weight: 400;
		line-height: 17px;
		word-wrap: break-word;
	}
	.development-by-col {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.development-by {
		color: #B2B6CC;
		font-size: 14px;
		font-family: Source Sans Pro;
		font-weight: 400;
		line-height: 17px;
		word-wrap: break-word;
	}
	.cadmean-logo {
		width: 20px;
		height: 20px;
	}
	.cadmean-title {
		color: #F85C50;
		font-size: 14px;
		font-family: Source Sans Pro;
		font-weight: 400;
		line-height: 17px;
		word-wrap: break-word;
	}
	.cadmean-row {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #F85C50;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 940px;
		}
	}
	@media(max-width: 960px) {
		.container {
			max-width: 620px;
		}
	}
	@media(max-width: 640px) {
		.container {
			max-width: 460px;
		}
	}
	@media(max-width: 480px) {
		.footer {
			padding: 35px 0;
		}
		.container {
			max-width: 300px;
			flex-direction: column;
			gap: 35px;
		}
		.loder-col {
			align-items: center;
		}
		.footer__nav {
			align-items: center;
		}
	}
</style>